/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
import { FluidImage as ImageType } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { CTA } from '../../@types/cta';

// Components
import Text, { TEXT_TYPES } from '../text';
import CTAButton from '../ctaButton';

// Styles
import { baseStyle } from './style';
import BackgroundImage from 'gatsby-background-image';
import classNames from 'classnames';

export interface ResourcesFeaturedDownloadProps {
  className?: string;
  title?: string;
  bodyText?: string;
  cta?: CTA;
  image?: ImageType;
  backgroundImage?: ImageType;
}

const ResourcesFeaturedDownload: FunctionComponent<ResourcesFeaturedDownloadProps> = React.memo(
  ({ title, bodyText, cta, image, className, backgroundImage }) => {
    const content = React.useMemo(
      () => (
        <Flex
          sx={baseStyle.mainContainer}
          className={classNames(className, backgroundImage && 'no-margin')}
        >
          <Box sx={baseStyle.mainContainerLeft}>
            {title && (
              <Text
                type={TEXT_TYPES.H2}
                sx={baseStyle.title}
                lines={['3', '2']}
              >
                {title}
              </Text>
            )}
            {bodyText && (
              <Text type={TEXT_TYPES.H5} sx={baseStyle.bodyText} lines="4">
                <span dangerouslySetInnerHTML={{ __html: bodyText }} />
              </Text>
            )}
            <CTAButton type="link" cta={cta} sx={baseStyle.cta}>
              {cta?.label}
            </CTAButton>
          </Box>

          <Flex sx={baseStyle.mainContainerRight}>
            <FluidImage {...image} sx={baseStyle.image} />
          </Flex>
        </Flex>
      ),
      [],
    );

    return backgroundImage ? (
      <BackgroundImage
        fluid={backgroundImage?.localFile?.childImageSharp?.fluid}
        sx={baseStyle.backgroundImage}
      >
        {content}
      </BackgroundImage>
    ) : (
      content
    );
  },
);

export default ResourcesFeaturedDownload;
